import React from "react";
import SocialProof from "./SocialProof";
import Headline from "./Headline";
import Cta from "./Cta";
import Testimonial from "./Testimonial";
import SyncVisual from "./SyncVisual";
import { MondayApiQueryInstance } from "@services/monday/monday-service-ts";
import useMondayContext from "@hooks/context/useMondayContext";
import useBoardAndItems from "../../../hooks/context/useBoardAndItems";
import useFireNudgeTrigger from "../../../hooks/api/useFireNudgeTrigger";

const EmptyStateBoardView = () => {
  const { appFeatureType } = useMondayContext();
  const { currentBoard } = useBoardAndItems();
  const fireNudge = useFireNudgeTrigger();

  const openSyncWizard = () => {
    // A3: "share item" clicked in a board view. Best-effort — deep-link to the
    // last created item on the board (skipped silently if the board is empty).
    if (appFeatureType === "AppFeatureBoardView" && currentBoard) {
      MondayApiQueryInstance.getLastCreatedItemId(currentBoard)
        .then((targetItemId) => {
          if (targetItemId) {
            fireNudge({
              source: "share_opened_board",
              itemid: targetItemId,
              boardid: currentBoard,
              viewType: "board_view",
            });
          }
        })
        .catch(() => {});
    }

    MondayApiQueryInstance.openAppFeatureModal("/sync-wizard", null, "650px", "580px");
  };

  return (
    <div className="flex overflow-y-auto flex-col flex-1 justify-center items-center px-8 py-10 min-h-0">
      <SocialProof />
      <Headline />
      <Cta openSyncWizard={openSyncWizard} />
      <Testimonial />
      <SyncVisual />
    </div>
  );
};

export default EmptyStateBoardView;
